class PricingItem {
  totalprice = 0;
  netprice = 0;
  companyid = null;
  companyname = "";
  discountedprice = "";
  insurancerequestid = 0;
  ratio = 0;
}
export default PricingItem;
